/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Table_Not_EmptyInputs */



/**
* | output |
* | --- |
* | "Cannot remove a table with players seated" |
*
* @param {Err_Tournament_Table_Not_EmptyInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_table_not_empty = /** @type {((inputs?: Err_Tournament_Table_Not_EmptyInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Table_Not_EmptyInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de retirer une table avec des joueurs assis")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se puede eliminar una mesa con jugadores sentados")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não é possível remover uma mesa com jogadores sentados")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile rimuovere un tavolo con giocatori seduti")
	return /** @type {LocalizedString} */ ("Cannot remove a table with players seated")
});